import styled from 'styled-components';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
//import PersonIcon from '@mui/icons-material/Person';
//import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
//import LockOpenIcon from '@mui/icons-material/LockOpen';
import { Bio } from '../../data/constants';


const FooterContainer = styled.div`
  width: 100%;
  padding: 2rem 0;
  display: flex;
  justify-content: center;
  background:  ${({ theme }) => theme.primary};
`;


const FooterWrapper = styled.footer`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  padding: 1rem;
  color: ${({ theme }) => theme.white};
  background:  ${({ theme }) => theme.primary};
`;

const LoginButton = styled.a`

    width: 13%;
    padding-top: 7px;
    padding-bottom: 7px;
    background-color: #ff3131;
    color: ${({ theme }) => theme.white};
    // box-shadow:  0 0 0 2px ${({ theme }) => theme.primary};
    border: 1.5px solid white;
    font-size: 15px;
    text-decoration:none;
    text-align:center;
    font-weight: 600;
    border-radius: 25px;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    &:hover  {
        transform: translateY(-2px);
        box-shadow:  0 0 0 2px #ff3131;
        border: 1.5px solid white;
        }
        @media (max-width: 768px) {
        display: none; /* Hide on mobile */
    }
`;

export const MobileLoginButton = styled.a`
  width: 50%;
    padding: 10px;
    background-color: #ff3131;
    color: ${({ theme }) => theme.white};
    // box-shadow:  0 0 0 2px ${({ theme }) => theme.primary};
    border: 1.5px solid white;
    font-size: 25px;
    text-decoration:none;
    text-align:center;
    font-weight: 600;
    border-radius: 25px;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    &:hover  {
        transform: translateY(-2px);
        box-shadow:  0 0 0 2px #ff3131;
    border: 1.5px solid white;
        }
        @media (max-width: 640px) {
            font-size:22px; 
            
          
          }
          @media (max-width: 640px) {
            
            font-size: 15px;
        }
        @media (min-width: 768px) { /* Hide on screens wider than 768px */
            display: none;
        }
`;


const SocialMediaIcons = styled.div`
  display: flex;
  margin-top: 1rem;
`;

const SocialMediaIcon = styled.a`
  display: inline-block;
  margin: 0 1rem;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.black};
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.white};
  }
`;

const Copyright = styled.p`
  margin-top: 1.5rem;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.soft2};
  text-align: center;
`;

function Footer() {
  return (
    <FooterContainer>
      <FooterWrapper>
        <LoginButton href="https://app.rindseotools.com/signup" target="_blank" rel="noopener noreferrer">Sign Up</LoginButton>
        <MobileLoginButton href="https://app.rindseotools.com/signup" target="_blank" rel="noopener noreferrer">Sign Up</MobileLoginButton>
        <LoginButton href="https://app.rindseotools.com/login" target="_blank" rel="noopener noreferrer">Members Login</LoginButton>
        <MobileLoginButton href="https://app.rindseotools.com/login" target="_blank" rel="noopener noreferrer">Members Login</MobileLoginButton>
        <SocialMediaIcons>
          <SocialMediaIcon href={Bio.facebook} target="display"><FacebookIcon /></SocialMediaIcon>
          <SocialMediaIcon href={Bio.whatsapp} target="display"><WhatsAppIcon /></SocialMediaIcon>
          <SocialMediaIcon href={Bio.linkedin} target="display"><LinkedInIcon /></SocialMediaIcon>
          {/*<SocialMediaIcon href={Bio.person} target="display"><PersonIcon /></SocialMediaIcon>*/}
          {/*<SocialMediaIcon href={Bio.personout} target="display"><PersonOutlineIcon /></SocialMediaIcon>*/}
          {/*<SocialMediaIcon href={Bio.lockicon} target="display"><LockOpenIcon /></SocialMediaIcon>*/}
         </SocialMediaIcons>
        <Copyright>
          <a href="https://toolbaazar.com" style={{color: '#ffffffff' , fontWeight: '600', cursor: 'pointer' }}> All rights reserved &copy; 2025</a> 
        </Copyright>

      </FooterWrapper>
    </FooterContainer>
  );
}

export default Footer;